import { splitByMatches } from './highlighted-text.business';

interface HighlightedTextProps {
  value: string;
  text: string;
}

export const HighlightedText: React.FC<HighlightedTextProps> = ({ value, text }) => (
  <>
    {splitByMatches(value, text).map(part =>
      part.isMatch ? <strong key={part.start}>{part.text}</strong> : part.text
    )}
  </>
);
